// src/components/Footer.js
import React from "react";
import {
  FiMapPin,
  FiPhone,
  FiMail,
  FiClock,
} from "react-icons/fi";

const Footer = () => {
  return (
    <footer style={footerStyle}>
      <div style={footerContainerStyle}>
        {/* Company Info */}
        <div style={companyInfoStyle}>
          <h3 style={companyNameStyle}>SRI GOKILAA CRACKERS</h3>
          <p style={footerTextStyle}>
            Firecracker specialists with over a decade of excellence in manufacturing, retailing, and wholesale distribution.
          </p>
        </div>

        {/* Contact Info - Horizontal Layout */}
        <div style={contactContainerStyle}>
          <div style={contactItemStyle}>
            <FiMapPin style={contactIconStyle} />
            <span style={contactTextStyle}>
           Sri Gokilaa Crackers 4/1 C, Rajamuthu Nagar Naranapuram Pudur, Sivakasi East, Tamil Nadu 626189
            </span>
          </div>
          
          <div style={contactItemStyle}>
            <FiPhone style={contactIconStyle} />
            <span style={contactTextStyle}>+91 9787009888 | +91 8428289235 | +91 7016139368</span>
          </div>
          
          <div style={contactItemStyle}>
            <FiMail style={contactIconStyle} />
            <span style={contactTextStyle}>srigokilaacrackers0@gmail.com</span>
          </div>
          
          <div style={contactItemStyle}>
            <FiClock style={contactIconStyle} />
            <span style={contactTextStyle}>Mon-Sun: 9AM - 10PM</span>
          </div>
        </div>
      </div>

      <div style={copyrightStyle}>
        <p style={copyrightTextStyle}>
          © {new Date().getFullYear()} Sri Gokilaa Crackers. All Rights Reserved.
          <br />
          <a
            href="https://vivifysofttech.in"
            target="_blank"
            rel="noopener noreferrer"
            style={developerLinkStyle}
          >
            Developed by VivifySoftTech
          </a>
        </p>
      </div>
    </footer>
  );
};

// === Footer Styles ===
const footerStyle = {
  backgroundColor: '#1a237e',
  color: 'white',
 padding:"10px"
};

const footerContainerStyle = {
  maxWidth: '1200px',
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  paddingBottom: '1rem',
};

const companyInfoStyle = {
  textAlign: 'center',
  marginBottom: '0.5rem',
};

const companyNameStyle = {
  fontSize: '1.3rem',
  margin: '0.2rem 0 0.5rem 0',
  color: 'white',
  fontWeight: 'bold',
};

const footerTextStyle = {
  fontSize: '0.85rem',
  lineHeight: '1.4',
  color: '#e0e0e0',
  margin: '0.2rem 0',
};

const contactContainerStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: '1.5rem',
  margin: '0 auto',
  maxWidth: '100%',
};

const contactItemStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  margin: '0.2rem 0',
  flex: '1 0 auto',
  maxWidth: '350px',
};

const contactIconStyle = {
  fontSize: '1rem',
  color: '#FF9800',
  minWidth: '1rem',
  flexShrink: 0,
};

const contactTextStyle = {
  fontSize: '0.85rem',
  color: '#e0e0e0',
  lineHeight: '1.3',
};

const copyrightStyle = {
  borderTop: '1px solid #3949AB',
  textAlign: 'center',
  maxWidth: '1200px',
  margin: '0 auto',
  paddingTop: '0.8rem',
};

const copyrightTextStyle = {
  fontSize: '0.85rem',
  color: '#e0e0e0',
  margin: '0',
  lineHeight: '1.4',
};

const developerLinkStyle = {
  color: '#FF9800',
  textDecoration: 'none',
  fontWeight: '500',
  transition: 'all 0.3s ease',
};

export default Footer;